import { Component, Input, OnInit } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { CalculatorChangeDialogComponent } from 'app/modules/shared/components/calculator-change-dialog/calculator-change-dialog.component';

@Component({
  selector: 'app-calculate-change',
  templateUrl: './calculate-change.component.html',
  styleUrls: ['./calculate-change.component.scss'],
})
export class CalculateChangeComponent implements OnInit {
  @Input() data: any;

  constructor(private dialogService: DialogService) {}

  ngOnInit() {}

  openCalculator() {
    const ref = this.dialogService.open(CalculatorChangeDialogComponent, {
      width: '35%',
      styleClass: 'small-heading-dialog',
      showHeader: false,
      data: {
        payment: this.data,
      },
    });

    const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
      onClose.unsubscribe();
    });
  }
}
